import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TabButtonsComponent} from './tab-buttons/tab-buttons.component';
import {RouterModule} from '@angular/router';


@NgModule({
    declarations: [
        TabButtonsComponent
    ],
    imports: [
        CommonModule,
        RouterModule
    ],
    exports: [
        TabButtonsComponent
    ]
})
export class TabButtonsModule {
}

export {TabButton} from './tab-buttons/tab-buttons.component';
